import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ScrappedExamService = sdk.getService('ScrappedExamService');

export const useAllScrappedExamsForSelectors = () => {
  const queryKey = ['scrapped-exams', 'all'];

  const { isLoading, data } = useQuery({
    queryKey,
    queryFn: () => ScrappedExamService.findAllScrappedExams()
  });

  return {
    scrappedExams: data,
    isLoading
  };
};
